<section class="main-section p-md-3">

    <div class="container row gx-0 gy-0 p-2 w-100">

        <div *ngFor="let item of lst_Menu" class="col-lg-4 col-md-6 col-12 p-2">

            <div class="menu-item p-2" [routerLink]="item.routerLink" (click)="item?.iAction ? showAction(item?.iAction) : ''">

                <div class="img-container">

                    <img [src]="item.strImage" [alt]="item.strTitle">

                </div>

                <div class="title-container">

                    <p class="fw-bold"> {{ item.strTitle }} </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- مدال افزودن سرویس -->

<div class="modal fade" id="newReq_Modal">    

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content">

            <div class="modal-header">

                <h3 class="modal-title mb-0"> ثبت درخواست سفر </h3>

                <button type="button" class="btn" data-bs-dismiss="modal">

                    <mat-icon class="d-flex mat-18">close</mat-icon>

                </button>
                

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-md-0 gy-2 p-2">
                    
                    <!-- موبایل مسافر -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> * موبایل مسافر </label>
            
                        <input class="form-control p-2 text-center"
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            maxlength="11"

                            formControlName="strMobile">

                        <ng-container *ngIf="bEditMode != 'showMode'">

                            <button class="btn btn-info rounded" (click)="search_ByMobile()">

                                <i class="fa fa-search" aria-hidden="true"></i>
                                
                            </button>

                        </ng-container>
            
                    </div>

                    <!-- نام مسافر -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> نام مسافر </label>
            
                        <input class="form-control p-2 text-center" formControlName="strName">
            
                    </div>

                    <!-- نام خانوادگی مسافر -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> * نام خانوادگی مسافر </label>
            
                        <input class="form-control p-2 text-center" formControlName="strFamily">
            
                    </div>

                    <!-- جنسیت -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> جنسیت </label>
            
                        <select class="form-select p-2" formControlName="tiSex">
            
                            <option class="text-center" [value]="1"> مرد </option>

                            <option class="text-center" [value]="1"> زن </option>
            
                        </select>
            
                    </div>

                    <!-- تاریخ سفر -->

                    <div class="position-relative col-12 col-md-4 p-2"> 
                
                        <label class="mb-2 text-muted"> * تاریخ سفر </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strDate" class="form-control p-2 text-start" />
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- ساعت سفر -->
                        
                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> * ساعت سفر </label>

                        <div class="input-group clockpicker">

                            <input class="form-control p-2 text-center" formControlName="strTime" [format]="24" [ngxTimepicker]="picker">

                            <ngx-material-timepicker #picker [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn"> </ngx-material-timepicker>

                            <ng-template #cancelBtn>

                                <button class="Btn_timePicker" style="margin-right: 10px;background-color: #ff0000;"> لغو </button>

                            </ng-template>

                            <ng-template #confirmBtn>

                                <button class="Btn_timePicker " style="background-color: #009620;"> تایید </button>

                            </ng-template>

                        </div>

                    </div>

                    <!-- شهر مبداء -->

                    <div class="position-relative col-12 col-md-4 p-2">
        
                        <label class="text-muted"> * شهر مبداء </label>
    
                        <custom-filter *ngIf="showFilter"

                            [strValue]="returnStrValue(bEditMode || bEditMode == 'searchMode' || isCity ? 'strCity' : 'strSCity', mdl_Request.get('strSCity')?.value,lst_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: start']"
                    
                            [str_Placeholder]="' جستجو کنید...'"
                    
                            [lst_Main]="lst_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="mdl_Request.disabled || isCity ? true : false"
                            
                            (hideOptions)="setValue_Filter($event,'strSCity')">
                
                        </custom-filter>
    
                    </div>

                    <!-- آدرس مبداء -->

                    <div class="position-relative col-12 col-md-8 p-2">

                        <label class="mb-2 text-muted"> * آدرس مبداء  </label>

                        <input class="form-control p-2 text-end" 

                            [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مبداء خود را جستجو کنید ...' "
                        
                            formControlName="strSAddress">    

                        <ng-container *ngIf="bEditMode != 'showMode'">

                            <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')" [disabled]="mdl_Request.get('strSCity')?.value == ''">

                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                            
                            </button>

                        </ng-container>

                
                    </div>

                    <!-- شهر مقصد -->

                    <div class="position-relative col-12 col-md-4 p-2">
        
                        <label class="text-muted"> * شهر مقصد </label>
    
                        <custom-filter *ngIf="showFilter"

                            [strValue]="returnStrValue(bEditMode || isCity ? 'strCity' : 'strDCity',mdl_Request.get('strDCity')?.value,lst_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: start']"
                    
                            [str_Placeholder]="' جستجو کنید...'"
                    
                            [lst_Main]="lst_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="mdl_Request.disabled || isCity ? true : false"
                            
                            (hideOptions)="setValue_Filter($event,'strDCity')">
                
                        </custom-filter>
    
                    </div>

                    <!-- آدرس مقصد -->

                    <div class="position-relative col-12 col-md-8 p-2">

                        <label class="mb-2 text-muted"> آدرس مقصد </label>

                        <input class="form-control p-2 text-end" 

                            [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مقصد خود را جستجو کنید ...' "
                        
                            formControlName="strDAddress">    

                        <ng-container *ngIf="bEditMode != 'showMode'">

                            <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')" [disabled]="mdl_Request.get('strDCity')?.value == ''">

                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                            
                            </button>

                        </ng-container>
                                           
                    </div>

                    <!-- مدال نقشه -->
                    
                    <app-custom-map *ngIf="showCustom_Map"
                    
                        [strValue]="mdl_Map.get('strAddress')?.value"
            
                        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                        [isOpenModal]="true"

                        (mdl_Submit)="submitMap($event)">
    
                    </app-custom-map>
                    
                    <!-- رفت و برگشت -->

                    <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCameBack')?.value || bEditMode != 'showMode'">

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-4 p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bCameBack" formControlName="bCameBack">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bCameBack"> رفت و برگشت </label>
                        
                        </div>

                    </ng-container>

                    <!-- گروه خودرویی -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> گروه خودرویی </label>
            
                        <select class="form-select p-2" formControlName="tiMobileGroup" (change)="reset_calc()">
            
                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lst_GroupCar" [value]="item.tiMobileGroup">

                                {{item.strComment}}
            
                            </option>
            
                        </select>
            
                    </div>

                    <!-- کرایه سفر -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> کرایه سفر(ریال)</label>
            
                        <input class="form-control p-2 text-center" [value]="mdl_Request.get('iEstimateRent')?.value" disabled>

                        <ng-container *ngIf="bEditMode != 'showMode'">

                            <button class="btn btn-info rounded" (click)="calc_Renting()">

                                <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
                            
                            </button>

                        </ng-container>

                        <ng-container *ngIf="mdl_Request.get('iDiscount')?.value > 0">

                            <small class="text-danger"> تخفیف : {{ mdl_Request.get('iDiscount')?.value | number:'1.0-0' }} ریال </small>

                        </ng-container>

            
                    </div>

                    <!-- کرایه اعلام شده -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> کرایه اعلام شده(ریال)</label>
            
                        <input class="form-control p-2 text-center"
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                            [value]="putSeparator(mdl_Request.get('iPartnerRent')?.value,bEditMode) "

                            formControlName="iPartnerRent">
            
                    </div>

                    <!-- مبلغ دریافتی (ریال) -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> مبلغ دریافتی (ریال) </label>
            
                        <input class="form-control p-2 text-center"
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                            [value]="putSeparator(mdl_Request.get('iPartnerReceived')?.value,bEditMode) "

                            formControlName="iPartnerReceived">
            
                    </div>

                    <!-- تعداد مسافر -->

                    <div class="position-relative col-12 col-md-4 p-2">
                
                        <label class="mb-2 text-muted"> تعداد مسافر </label>
            
                        <input class="form-control p-2 text-center" oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiPassenger">
            
                    </div>

                    <!-- کرایه مخفی باشد -->

                    <ng-container *ngIf="!isCity">

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bHiddenFare')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bHiddenFare" formControlName="bHiddenFare">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bHiddenFare"> کرایه مخفی باشد </label>
                            
                            </div>

                        </ng-container>

                    </ng-container>

                    <!-- استعمال دخانیات -->

                    <ng-container *ngIf="!isCity">

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bSmoking')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bSmoking" formControlName="bSmoking">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bSmoking"> استعمال دخانیات </label>
                            
                            </div>

                        </ng-container>

                    </ng-container>


                    <!-- سرویس شامل بار می باشد -->
    
                    <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCargo')?.value || bEditMode != 'showMode'">
    
                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bCargo" formControlName="bCargo">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bCargo"> سرویس شامل بار می باشد </label>
                        
                        </div>

                    </ng-container>
                    
                    <!-- توضیحات بار -->

                    <div *ngIf="mdl_Request.get('bCargo')?.value" class="position-relative col-12 col-md-12 p-2">

                        <ng-container *ngIf="mdl_Request.get('bCargo')?.value">
           
                            <label class="mb-2 text-muted"> توضیحات بار </label>
                
                            <input class="form-control p-2 text-end" formControlName="strCargoDetail">

                        </ng-container>
            
                    </div>

                    <!-- مسافر غیر ایرانی -->

                    <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bForeigner')?.value || bEditMode != 'showMode'">

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bForeigner" formControlName="bForeigner">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bForeigner"> مسافر غیر ایرانی </label>
                        
                        </div>

                    </ng-container>
                    
                    <!-- شماره پاسپورت -->

                    <div *ngIf="mdl_Request.get('bForeigner')?.value" class="position-relative col-12 p-2">
            
                        <label class="mb-2 text-muted"> شماره پاسپورت </label>
            
                        <input placeholder="شماره پاسپورت مسافر غیر ایرانی را وارد کنید" class="form-control p-2 text-end" formControlName="strPassportNumber">
            
                    </div>

                    <!-- توضیحات -->
                
                    <div class="position-relative col-12 p-2">
                
                        <label class="mb-2 text-muted"> توضیحات </label>
            
                        <textarea style="height: 48px;resize: none;" class="form-control" formControlName="strComment"></textarea>
            
                    </div>
                    
            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- ثبت -->

                <button class="btn btn-success px-3" (click)="submit_Request()">

                    &nbsp; ثبت &nbsp;

                </button>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال تغییر رمز عبور -->

<div class="modal fade" id="PW_Modal">    

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content">

            <div class="modal-header">

                <h3 class="modal-title mb-0"> تغییر رمز عبور </h3>

                <button type="button" class="btn" data-bs-dismiss="modal">

                    <mat-icon class="d-flex mat-18">close</mat-icon>

                </button>
                

            </div>

            <div class="modal-body p-2">

                <div [formGroup]="mdl_PW" class="container-fluid row gx-2 gy-md-0 gy-2 p-2">

                    <!--  رمز عبور فعلی -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * رمز عبور فعلی </label>

                        <input type="password" formControlName="currentPassword" class="form-control p-2 text-center">

                      </div>

                    </div>
                  
                    <!-- رمز عبور جدید -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * رمز عبور جدید </label>

                        <input type="password" formControlName="newPassword" (input)="checkPasswordStrength()" class="form-control p-2 text-center">

                        <div class="strength-meter mt-2">

                          <div class="strength-bar" [ngClass]="passwordStrength"></div>

                        </div>

                        <small class="text-muted">{{ passwordStrengthMessage }}</small>

                      </div>

                    </div>
                  
                    <!-- تکرار رمز عبور جدید -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * تکرار رمز عبور جدید </label>

                        <input type="password" formControlName="confirmPassword" class="form-control p-2 text-center">

                      </div>

                    </div>

                    <!-- راهنمای رمز عبور قوی -->

                    <div class="d-none hints col-12 d-flex justify-content-center align-items-center p-2">

                        <ul class="input-container position-relative w-50 p-2">

                            <li [class.text-success]="hasUpperCase">شامل حداقل یک حرف بزرگ</li>

                            <li [class.text-success]="hasLowerCase">شامل حداقل یک حرف کوچک</li>

                            <li [class.text-success]="hasNumbers">شامل حداقل یک عدد</li>

                            <li [class.text-success]="hasSpecialChars">{{ 'شامل حداقل یک کاراکتر خاص (!@#$%^&*)' }}</li>

                            <li [class.text-success]="isLongEnough"> {{ 'حداقل 8 کاراکتر' | faNum }} </li>

                        </ul>
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- تایید -->

                <button class="btn btn-success px-3" (click)="submit_Password()">

                    &nbsp; تایید &nbsp;

                </button>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>